// @ts-strict-ignore
import { memo, MouseEvent } from 'react'

import { useOpenAccessoriesOffer } from '@/features/cart/accessories-offer'
import { AddToCart } from '@/features/cart/add-to-cart'
import { CreateFastOrder } from '@/features/order/create-fast-order'

import { CatalogItemLocation } from '@/shared/types/product'
import { OrderType, ProductControl, TProduct } from '@/shared/types/product-types'
import { Button } from '@/shared/ui'

import { YandexBadgesClient } from '../YandexBadges/YandexBadges.client'

import cl from './BottomControllerOrder.module.scss'

interface BottomControllerOrderProps {
	productData: TProduct
	type: 'regular' | 'wide' | 'wideOnMobile'
	noFastOrder: boolean
	price?: number
	buttonName?: string
}

export const BottomControllerOrder = memo((props: BottomControllerOrderProps) => {
	const { type, productData, noFastOrder, price, buttonName } = props
	const { loadingAction, openAccessoriesOffer, openOrderWithAccessories } = useOpenAccessoriesOffer()
	const productPreview = { TITLE: productData.TITLE, IMAGE: productData.IMAGE || productData.IMAGES?.[0] }
	const isPreOrder =
		productData.ORDER_TYPE === OrderType.PreOrder || productData.CONTROL?.includes(ProductControl.Preorder)
	const isMainActionLoading = loadingAction === 'cart' || loadingAction === 'preorder'
	const openAccessories = (action: 'cart' | 'fast', waitFor?: Promise<unknown>) =>
		openAccessoriesOffer({ action, productCode: productData.KOD, productId: productData.ID, productPreview }, waitFor)
	const onPreOrder = (event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation()
		event.preventDefault()
		return openOrderWithAccessories({
			action: 'preorder',
			productCode: productData.KOD,
			productId: productData.ID,
			productPreview
		})
	}

	return (
		<>
			<YandexBadgesClient price={price} cardType={type} />
			<div className={cl[type]} data-name="bottom-controller">
				{isPreOrder ? (
					<Button
						className={cl.button}
						onClick={onPreOrder}
						isLoading={isMainActionLoading}
						disabled={isMainActionLoading}>
						{buttonName ?? 'Купить'}
					</Button>
				) : (
					<AddToCart
						productData={productData}
						location={CatalogItemLocation.ProductCard}
						className={cl.button}
						buttonName={buttonName}
						isPending={isMainActionLoading}
						onAddStarted={addPromise => void openAccessories('cart', addPromise)}
						onInCartClick={() => openAccessories('cart')}
					/>
				)}
				{!noFastOrder && (
					<CreateFastOrder
						productId={productData.ID}
						className={cl.button}
						KOD={productData.KOD}
						onFastOrder={() => openAccessories('fast')}
						isLoading={loadingAction === 'fast'}
					/>
				)}
			</div>
		</>
	)
})
